import { render, staticRenderFns } from "./StudentOfferInformations.vue?vue&type=template&id=273f3926&scoped=true&"
import script from "./StudentOfferInformations.vue?vue&type=script&lang=ts&"
export * from "./StudentOfferInformations.vue?vue&type=script&lang=ts&"
import style0 from "./StudentOfferInformations.vue?vue&type=style&index=0&id=273f3926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f3926",
  null
  
)

export default component.exports